import React from "react";

import {
  building07,
  calendar,
  currencyPoundCircle,
  wallet02,
} from "../../../lib/icons/untitled_ui/SVGs";
import { formatAmount } from "../landing_utils";

import css from "./BuyerInfo.module.scss";

type Props = {
  name: string;
  buyerLink?: string;
  type?: "preTender" | "openTender" | "awarded";
  value?: number;
  currency?: string;
  supplier?: string;
  expiryDate?: string;
  closeDate?: string;
};

export default function BuyerInfo({
  name,
  buyerLink,
  type,
  value,
  currency,
  supplier,
  expiryDate,
  closeDate,
}: Props) {
  return (
    <div className={css.buyerInfo}>
      <div className={css.buyerInfoItem}>
        <div className={css.titleContainer}>
          <div className={css.bullet}>{wallet02}</div>
          <h2 className={css.title}>Buyer</h2>
        </div>
        <p className={css.description}>{buyerLink ? <a href={buyerLink}>{name}</a> : name}</p>
      </div>

      {!!value && (
        <div className={css.buyerInfoItem}>
          <div className={css.titleContainer}>
            <div className={css.bullet}>{currencyPoundCircle}</div>
            <h2 className={css.title}>Value</h2>
          </div>
          <p className={css.description}>{formatAmount(value, currency ?? null)}</p>
        </div>
      )}

      {!!closeDate && (
        <div className={css.buyerInfoItem}>
          <div className={css.titleContainer}>
            <div className={css.bullet}>{calendar}</div>
            <h2 className={css.title}>{type == "preTender" ? "Start date" : "Close date"}</h2>
          </div>
          <p className={css.description}>{closeDate}</p>
        </div>
      )}

      {!!supplier && (
        <div className={css.buyerInfoItem}>
          <div className={css.titleContainer}>
            <div className={css.bullet}>{building07}</div>
            <h2 className={css.title}>Current supplier</h2>
          </div>
          <p className={css.description}>{supplier}</p>
        </div>
      )}

      {!!expiryDate && (
        <div className={css.buyerInfoItem}>
          <div className={css.titleContainer}>
            <div className={css.bullet}>{calendar}</div>
            <h2 className={css.title}>Expiry date</h2>
          </div>
          <p className={css.description}>{expiryDate}</p>
        </div>
      )}
    </div>
  );
}
